module.exports = __webpack_public_path__ + "img/3화_19(1).c3dd8275.jpg";